/** Removes editor-only comment anchors while preserving the underlying prose. */
export function stripCommentAnchors(html: string): string {
  const template = document.createElement('template');
  template.innerHTML = html;

  template.content.querySelectorAll('span[data-comment-id]').forEach((element) => {
    element.replaceWith(...Array.from(element.childNodes));
  });
  template.content.querySelectorAll('[data-comment-id]').forEach((element) => {
    element.removeAttribute('data-comment-id');
  });
  template.content.querySelectorAll('.comment-mark').forEach((element) => {
    element.classList.remove('comment-mark');
    if (!element.getAttribute('class')) element.removeAttribute('class');
  });

  return template.innerHTML;
}
